export const makeBannerLink = (linkType, linkId) => {
  if (linkType && linkId) {
    const page = linkType === 1 ? `collection/${linkId}` : `category/${linkId}/subcategory/0`;
    const domain = window.location.href;
    const url = `${domain}${page}`; 
    return url;
  } else {
    return null;
  }
}